import { cn, hasMessage } from '@/lib/utils';
import { MutableRefObject } from 'react';

import { FileSpec, useChatMessages } from '@chainlit/react-client';

import WaterMark from '@/components/WaterMark';

import MessageComposer from './MessageComposer';

interface Props {
  fileSpec: FileSpec;
  onFileUpload: (payload: File[]) => void;
  onFileUploadError: (error: string) => void;
  autoScrollRef: MutableRefObject<boolean>;
  showIfEmptyThread?: boolean;
  variant?: 'default' | 'compact';
}

export default function ChatFooter({
  showIfEmptyThread,
  variant = 'default',
  ...props
}: Props) {
  const { messages } = useChatMessages();
  if (!hasMessage(messages) && !showIfEmptyThread) return null;

  return (
    <div className={cn('relative flex w-full flex-col items-center gap-1.5')}>
      <MessageComposer {...props} variant={variant} />
      <WaterMark />
    </div>
  );
}
